module.exports = __webpack_public_path__ + "img/increased-revenue.c7243cfa.svg";